import { CouponCode, Payment } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: `${routesMap.PAYMENT.path}/:id`,
      name: "PAYMENT",
      key: `${routesMap.PAYMENT.path}/:id`,
      // commonRoute: false,
      private: true,
      // withAuth: true,
      // belongsToHeader: true,
      element: <Payment />,
    },
    {
      path: `${routesMap.COUPON.path}/:id`,
      name: "COUPON",
      key: `${routesMap.COUPON.path}/:id`,
      private: true,
      element: <CouponCode />,
    },
  ];
}
